import moment from 'moment';

export class DateFormatValueConverter {
	toView(value, format) {
        if(!value) return '';
        if (format === 'humanize') {
            return moment.utc(value).local().fromNow();
        }

		return moment.utc(value).local().format(format || 'MM/DD/YY');
	}
}
